import { useMemo, useState } from "react";
import TagListLinks from "components/tags/TagListLinks";
import Button from "hardcover-ui/components/Button";
import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import pluralize from "lib/pluralize";
import { TagSerializersBasicTag } from "types/serializers";

export default function TagGroup({ tags }: { tags: TagSerializersBasicTag[] }) {
  const category = tags.length > 0 ? tags[0].category : null;
  const [showAllSpoilers, setShowAllSpoilers] = useState(false);
  if (tags.length === 0) {
    return <></>;
  }
  const hasSpoilers = useMemo(() => {
    if (category === "Content Warning") {
      return true;
    }
    return (
      tags.filter((tag) => {
        const ratio = tag.spoilerRatio;
        return ratio > 0.5;
      }).length > 0
    );
  }, [tags]);

  // If this is a content warning:
  // Always show the "show button"
  // Pass true for hideSpoilers
  // Otherwise
  // Only show the "show button" if there is a spoiler
  // Pass false for hideSpoilers, unless they've clicked "show"
  return (
    <div>
      <div className="flex flex-row space-x-4">
        <Heading size="sm" level={3} className="mb-1">
          {pluralize(category, tags.length)}
        </Heading>
        {hasSpoilers && !showAllSpoilers && (
          <Button onClick={() => setShowAllSpoilers(true)}>
            <Text variant="secondary" size="sm" className="hover:underline">
              Show
            </Text>
          </Button>
        )}
      </div>
      <TagListLinks
        tags={tags}
        limit={5}
        showCount={false}
        showSpoilers={hasSpoilers && showAllSpoilers}
      />
    </div>
  );
}
